export default __webpack_public_path__ + "static/media/jude.51001939.webp";